import { IAddressFields, ILoggedIn, RootState } from '@checkout/state';
import * as cx from 'classnames';
import { Field } from 'formik';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { ICheckoutContextConfig } from './../../../config/contextCheckoutConfig.d';
import * as Styles from './ContactDetailsForm.scss';
import { getContactDetailsFormModel } from './ContactDetailsFormModel';

interface IOwnProps {
  trySubmit?: boolean;
  fields: IAddressFields;
  formName: string;
  checkoutContextConfig: ICheckoutContextConfig;
  readOnly?: boolean;
  handleExtSubmitForm?: (submitFormFunction: () => void) => void;
}

interface IConnectetDispatchProps {}

interface IConnectedProps {
  country: string;
  loggedIn: ILoggedIn | null;
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class ContactDetailsForm extends React.Component<Props, {}> {

  render() {
    const { readOnly, fields, formName, intl, country, checkoutContextConfig, loggedIn } = this.props;
    if (!fields) { return null; }
    const addersFormModel = getContactDetailsFormModel(fields, formName, intl, checkoutContextConfig, loggedIn !== null);

    const contactDetailsFieldsClassNames = cx({
      [Styles.fieldset]: true,
      [Styles.addressReadOnly]: readOnly,
    });

    return (
      <div className={contactDetailsFieldsClassNames}>
        {addersFormModel.map((field) => {
          const { visible, name, ...fieldProps } = field;

          return visible && (
            <Field
              {...fieldProps}
              key={`${formName}.${name}`}
              id={`${formName}.${name}`}
              name={`${formName}.${name}`}
              readOnly={readOnly}
              country={country}
            />
          );
        })}
      </div>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({
      country: state.checkout.location.country,
      loggedIn: state.checkout.loggedIn,
    }),
    {},
  )
)(ContactDetailsForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/ContactDetailsForm/ContactDetailsForm.tsx